import { render, staticRenderFns } from "./DiagnosisTemplate.vue?vue&type=template&id=91487ebe&scoped=true"
import script from "./DiagnosisTemplate.vue?vue&type=script&lang=js"
export * from "./DiagnosisTemplate.vue?vue&type=script&lang=js"
import style0 from "./DiagnosisTemplate.vue?vue&type=style&index=0&id=91487ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91487ebe",
  null
  
)

export default component.exports